import type { Timestamp } from 'firebase/firestore'

export enum UserType {
  SUPER_ADMIN = 'superAdmin',
  ADMIN = 'admin',
  USER = 'user',
  PR_MEMBER = 'prMember',
  PR_MANAGER = 'prManager',
  MEDIA_MEMBER = 'mediaMember',
  SPORTS_FAN = 'sportsFan',
}

export type UserInput = Omit<User, 'id' | 'createdAt'>

export interface User {
  id?: string
  email?: string
  password?: string
  fullName?: string
  phone?: string
  companyId?: string
  profilePicUrl?: string
  mediaOutletName?: string
  userType?: UserType
  isRoot?: boolean
  active?: boolean
  canPost?: boolean
  followings?: string[]
  notifications?: string[]
  emailVerified?: boolean
  createdViaInvite?: boolean
  invitedAt?: Timestamp // Date when user accepted the invite (original invite creation date)
  createdAt?: Timestamp
  updatedAt?: Timestamp
  address?: {
    city?: string
    state?: string
  }
  expoPushToken?: string // Expo push notification token for mobile app
  expoPushTokenUpdatedAt?: Timestamp // When the token was last updated
}
